/**
 * SELECT OPTIONS PESTLE
 *
 * @version 0.1
 */

import React from 'react';
import { injectIntl } from 'react-intl';

function SelectOptionsPestle({pestle, onChange, intl}) {

    let PESTLE_SELECT_OPTIONS = {
        'ANY_PESTLE':    'Entities_Preview_UIText_previewCompanies.selectOptionsPestle.allRiskAngles',
        'political':     'Entities_Preview_UIText_previewCompanies.selectOptionsPestle.political',
        'economic':      'Entities_Preview_UIText_previewCompanies.selectOptionsPestle.economic',
        'social':        'Entities_Preview_UIText_previewCompanies.selectOptionsPestle.social',
        'technological': 'Entities_Preview_UIText_previewCompanies.selectOptionsPestle.technological',
        'legal':         'Entities_Preview_UIText_previewCompanies.selectOptionsPestle.legal',
        'environmental': 'Entities_Preview_UIText_previewCompanies.selectOptionsPestle.environmental'
    };

    let pestles = Object.keys(PESTLE_SELECT_OPTIONS);

    let newPestle;

    if (typeof pestle === 'string') {
        newPestle = pestle;
    } else {
        if (pestle.political && pestle.economic && pestle.social && pestle.technological && pestle.legal && pestle.environmental) {
            newPestle = 'ANY_PESTLE';
        } else if (pestle.political) {
            newPestle = 'political';
        } else if (pestle.economic) {
            newPestle = 'economic';
        } else if (pestle.social) {
            newPestle = 'social';
        } else if (pestle.technological) {
            newPestle = 'technological';
        } else if (pestle.legal) {
            newPestle = 'legal';
        } else if (pestle.environmental) {
            newPestle = 'environmental';
        } else {
            newPestle = 'ANY_PESTLE';
        }
    }


    if (!PESTLE_SELECT_OPTIONS[newPestle]) {
        newPestle = 'ANY_PESTLE';
    }

    return (
        <select className="notranslate risk-angle-select"
                defaultValue={newPestle}
                onChange={onChange}
                title={intl.formatMessage({id: PESTLE_SELECT_OPTIONS[newPestle]})}>

            {
                pestles.map((pestle) => (
                    <option key={'pestle-option-' + pestle} value={pestle}>
                        {intl.formatMessage({id: PESTLE_SELECT_OPTIONS[pestle]})}
                    </option>
                ))
            }

        </select>
    );

}

export default injectIntl(SelectOptionsPestle);


// WEBPACK FOOTER //
// ./src/scripts/reusable/Dropdowns/SelectOptionsPestle.jsx